import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import Reveal from './Reveal';
import './Policies.css';

const POLICIES = [
  {
    icon: 'users',
    title: 'Customer Policy',
    text: 'How we handle your orders, payments, data and support as a BikesDrop customer.',
    appKey: 'user',
    theme: 'teal',
  },
  {
    icon: 'shield',
    title: 'Rider & Driver Policy',
    text: 'Requirements, conduct, earnings and support terms for everyone riding for BikesDrop.',
    appKey: 'rider',
    theme: 'teal',
  },
  {
    icon: 'briefcase',
    title: 'Merchant Policy',
    text: 'Terms for listing your business, receiving orders and getting paid through BikesDrop.',
    appKey: 'merchant',
    theme: 'amber',
  },
  {
    icon: 'truck',
    title: 'Vendor Policy',
    text: 'Terms for BikesDrop delivery partner vendors, covering shop applications, deliveries and point of sale.',
    appKey: 'vendor',
    theme: 'teal',
  },
];

export default function Policies() {
  return (
    <section className="policies section section--tight" id="policies">
      <div className="container">
        <Reveal className="policies__head">
          <span className="eyebrow eyebrow--teal">Transparent by Design</span>
          <h2 className="section-heading">Our policies, in the open</h2>
          <p className="section-sub">
            Every side of BikesDrop, customers, riders, drivers, merchants and delivery partner
            vendors, has a clear, public policy explaining how the platform works for them, kept
            current by the BikesDrop team.
          </p>
        </Reveal>

        <div className="policies__grid">
          {POLICIES.map((p, i) => (
            <Reveal delay={i * 80} key={p.title}>
              <Link className={`policy-card policy-card--${p.theme}`} to={`/policies/${p.appKey}/`}>
                <span className="policy-card__icon">
                  <Icon name={p.icon} size={22} />
                </span>
                <h3>{p.title}</h3>
                <p>{p.text}</p>
                <span className="policy-card__link">Read policy →</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
